import { _ as __assign } from '../../chunks/bundle-Ca6003_X.js';
import React__default from 'react';
import { S as SuggestedMentionListView } from '../../chunks/bundle-MhQ-_j2c.js';
import '../../chunks/bundle-DDzCV2KR.js';
import '../../chunks/bundle-DLMIiDGU.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-91Yg-xh6.js';
import '../../chunks/bundle-zHBlW_wn.js';
import '../../ui/ImageRenderer.js';
import '../../chunks/bundle-C_bjYbrN.js';
import '../../chunks/bundle-s19NuPaM.js';
import '../../chunks/bundle-DGylLBIn.js';
import '../../chunks/bundle-C6Xiexo0.js';
import '../../chunks/bundle-DgPFpYZt.js';
import '../../chunks/bundle-B667kaG5.js';
import '../../chunks/bundle-ByN2OJfK.js';
import '../../chunks/bundle-Dcb1dUnS.js';
import '../../chunks/bundle-BSmdL6m-.js';
import '@sendbird/chat';
import '@sendbird/chat/groupChannel';
import '@sendbird/chat/openChannel';

var SuggestedMentionList = function (props) {
    return (React__default.createElement(SuggestedMentionListView, __assign({}, props)));
};

export { SuggestedMentionList, SuggestedMentionList as default };
//# sourceMappingURL=SuggestedMentionList.js.map
